import type { Application, GeoZone, ZoneGroup } from "../types";
import { applicationMatchesGeoZone } from "./geoZones";

/** Groups whose zone matches the application’s geography. */
export function zoneGroupsForApplication(app: Application, zones: GeoZone[], groups: ZoneGroup[]): ZoneGroup[] {
  const zoneIds = new Set(zones.filter((z) => applicationMatchesGeoZone(app, z)).map((z) => z.id));
  return groups.filter((g) => zoneIds.has(g.zoneId));
}

export function zoneGroupsForZone(zoneId: string, groups: ZoneGroup[]): ZoneGroup[] {
  return groups.filter((g) => g.zoneId === zoneId).sort((a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name));
}

/** Lookup category name for display (returns empty string if missing). */
export function categoryNameById(categories: { id: string; name: string }[], categoryId: string): string {
  return categories.find((c) => c.id === categoryId)?.name ?? "";
}
